import { api } from "../../services/NetworkBase";

// ENB-577: admin-only audit history. type is "orders", "samples" or "results".
// dateField is the record's own date to filter by (for example date_received); the dates are optional.
export async function GetAuditLog(type, dateField, startDate, endDate, searchText, page, pageSize) {
    try {
        let response = await api
            .get(`vlp/audit-log/${type}?dateField=${dateField}&startDate=${startDate}&endDate=${endDate}&searchText=${encodeURIComponent(searchText ?? "")}&page=${page}&pageSize=${pageSize}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

// Key values go in the query string: a result's parameter name can contain "/" and other URL characters.
export async function GetAuditLogDetail(type, orderNumber, sampleNumber, testCode, parameter) {
    try {
        const query = new URLSearchParams({ orderNumber });
        if (sampleNumber !== null && sampleNumber !== undefined && sampleNumber !== "") query.set("sampleNumber", sampleNumber);
        if (testCode) query.set("testCode", testCode);
        if (parameter) query.set("parameter", parameter);

        let response = await api
            .get(`vlp/audit-log/${type}/detail?${query.toString()}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}
